/**
 * Clasifica actuaciones en curso vs pasadas usando solo fecha y horas (sin depender de `estado`).
 * `fecha` en API suele ser medianoche UTC; se interpreta en calendario local del usuario.
 */

function parseHora(str) {
  const t = str != null ? String(str).trim() : '';
  const m = /^(\d{1,2}):(\d{2})/.exec(t);
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  if (h < 0 || h > 23 || min < 0 || min > 59) return null;
  return { h, min };
}

/**
 * Instante local (ms) en que la actuación se considera terminada para el histórico.
 * - Con `horaFin`: ese día a `horaFin`.
 * - Sin `horaFin` (solo fecha o solo inicio): fin del día local de esa fecha (23:59:59.999).
 * Sin `fecha`: null (no se clasifica como pasada por tiempo).
 */
export function getActuacionEndTimestampMs(act) {
  if (!act?.fecha) return null;
  const d = new Date(act.fecha);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const mo = d.getMonth();
  const day = d.getDate();
  const hf = parseHora(act.horaFin);
  if (hf) {
    return new Date(y, mo, day, hf.h, hf.min, 0, 0).getTime();
  }
  return new Date(y, mo, day, 23, 59, 59, 999).getTime();
}

export function isActuacionPast(act) {
  const end = getActuacionEndTimestampMs(act);
  if (end == null) return false;
  return end < Date.now();
}
